import k, { createContext as P, forwardRef as E, useContext as h } from "react";
import { c as b } from "./app-a75c1d35.mjs";
const m = P({
  isInsideBlock: !1
}), N = "block__content", S = "block__content--flex", B = "block__content--grid", _ = "block__content--limited-width", x = "desktop", A = "desktop--limited-width", T = "debug", e = {
  blockContent: N,
  blockContentFlex: S,
  blockContentGrid: B,
  blockContentLimitedWidth: _,
  desktop: x,
  desktopLimitedWidth: A,
  debug: T
}, G = E(function(n, l) {
  const {
    children: d,
    limitedWidth: c = !0,
    className: i,
    style: s,
    id: a,
    debug: r,
    itemScope: u = !1,
    itemType: L,
    flex: C
  } = n;
  if (!h(m).isInsideBlock)
    throw new Error("Content should be only used inside the Block.");
  const f = r && process.env.NODE_ENV === "development" ? "debug" : "";
  return /* @__PURE__ */ k.createElement(
    "div",
    {
      ref: l,
      className: b(
        i,
        e.blockContent,
        f,
        c && e.blockContentLimitedWidth,
        C ? e.blockContentFlex : e.blockContentGrid
      ),
      style: s,
      id: a,
      itemScope: u,
      itemType: L
    },
    d
  );
}), R = "block", v = "block--padding-top-large", W = "desktop", w = "block--padding-top-small", y = "block--padding-top-small--disabled", M = "block--padding-bottom-large", D = "block--padding-bottom-small", o = {
  block: R,
  blockPaddingTopLarge: v,
  desktop: W,
  blockPaddingTopSmall: w,
  blockPaddingTopSmallDisabled: y,
  blockPaddingBottomLarge: M,
  blockPaddingBottomSmall: D
};
var g = /* @__PURE__ */ ((t) => (t.NONE = "NONE", t.SMALL = "SMALL", t.LARGE = "LARGE", t))(g || {});
function p(t) {
  const {
    children: n,
    className: l,
    topPadding: d = "LARGE",
    bottomPadding: c = "LARGE",
    as: i,
    blockRef: s,
    ...a
  } = t, r = i || "div";
  return /* @__PURE__ */ k.createElement(
    r,
    {
      className: b(
        o.block,
        F(d),
        I(c),
        l
      ),
      ...a,
      ref: s
    },
    /* @__PURE__ */ k.createElement(m.Provider, { value: { isInsideBlock: !0 } }, n)
  );
}
p.Content = G;
p.Padding = g;
function F(t) {
  return t === "LARGE" ? o.blockPaddingTopLarge : t === "SMALL" ? o.blockPaddingTopSmall : "";
}
function I(t) {
  return t === "LARGE" ? o.blockPaddingBottomLarge : t === "SMALL" ? o.blockPaddingBottomSmall : "";
}
export {
  p as B,
  g as a
};
//# sourceMappingURL=Block-9b78bd10.mjs.map
